import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import App from "./App";
import LessonGenerator from "./pages/LessonGenerator";
import QuizGenerator from "./pages/QuizGenerator";
import UserGenerator from "./pages/UserGenerator";
// import Tutorial from "./containers/TutorialContainer/Tutorial";
import DashboardContainer from "./containers/DashboardContainer.js/DashboardContainer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          {/* <Route path="/tutorial" element={<Tutorial />} /> */}
          <Route path="/dashboard" element={<DashboardContainer />} />
          <Route path="/lessonGen" element={<LessonGenerator />} />
          <Route path="/QuizGen" element={<QuizGenerator />} />
          <Route path="/UserGen" element={<UserGenerator />} />
          {/* <Route path="/login/:role" element={<Login />} /> */}
          <Route path="/:id" element={<h1>Page 404 not found</h1>} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
